import React, { useEffect, useState } from 'react';

const CollapsibleSection = ({ title, children, startOpen = false, forceOpen = false }) => {
  const [isOpen, setIsOpen] = useState(startOpen);

  const toggleOpen = () => {
    setIsOpen((prevIsOpen) => !prevIsOpen);
  };

  useEffect(() => {
    if (forceOpen) {
      setIsOpen(true);
    }
  }, [forceOpen]);

  const styles = {
    section: {
      overflow: isOpen ? 'visible' : 'hidden',
      paddingRight: '5px',
    },
    header: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      padding: '12px 0',
      cursor: 'pointer',
      userSelect: 'none',
    },
    title: {
      margin: 0,
      fontSize: '1rem',
      fontWeight: 600,
    },
    icon: {
      border: 'solid #0067b1',
      borderWidth: '0 2px 2px 0',
      display: 'inline-block',
      padding: '3px',
      transform: isOpen ? 'rotate(-135deg)' : 'rotate(45deg)',
      transition: 'transform 0.3s ease-in-out',
    },
    content: {
      maxHeight: isOpen ? '1500px' : '0',
      overflow: isOpen ? 'visible' : 'hidden',
      transition: 'max-height 0.4s ease-in-out',
    },
  };

  return (
    <div style={styles.section}>
      <div style={styles.header} onClick={toggleOpen}>
        <h5 className="text-primary" style={styles.title}>
          {title}
        </h5>
        <span style={styles.icon} />
      </div>
      <div style={styles.content}>{children}</div>
    </div>
  );
};

export default CollapsibleSection;
